<template>
    <div>
        <EmployeeLink :user="value"/>
        <i class="fas fa-times text-danger ml-2" v-if="canRemove" @click="$emit(`remove`, value)"></i>
    </div>
</template>

<script>
import EmployeeLink from '@/components/EmployeeLink.vue';

export default {
    name: "UserCard",
    components: {
        EmployeeLink
    },
    props: {
        value: Object,
        canRemove: {
            type: Boolean,
            default: false
        }
    }
}
</script>

<style scoped>

</style>
